import { getLocale } from '@shopee/global-env';
import { getCountryConfig } from '@shopee/settings';
import { I18n } from '@shopee/platform';
import { Locale } from '@shopee/flow-types';

export const LOCALE = getLocale() as Locale;

const CountryConfig = getCountryConfig(LOCALE);
export const ADULT_AGE = CountryConfig.adultAge;

export const t = I18n.t;
